/* eslint-disable react/no-array-index-key */
import React, { useCallback } from 'react';
import DocumentService from '../utils/documentService';
import FilesDropzone from './FilesDropzone';

type Props = {
  setFile: (...args: any[]) => void,
  documents: Document[],
};

function MultiFileDropzone({
  documents,
  setFile,
}: Props) {
  const documentService = new DocumentService();
  const [filesUploading, setFilesUploading] = React.useState<File[]>([]);

  const handleDrop = useCallback((acceptedFiles) => {
    setFilesUploading([...filesUploading, ...acceptedFiles]);
    documentService.uploadDocuments(acceptedFiles).then((_documents) => {
      setFile(_documents.map((doc) => doc.id)[0]);
      setFilesUploading([]);
    });
  }, []);

  const handleRemove = (index: any) => {
    // delete the file
    setFile(null);
  };

  return (
    <FilesDropzone
      filesUploading={filesUploading}
      documents={documents}
      handleDrop={handleDrop}
      handleRemove={handleRemove}
    />
  );
}

export default MultiFileDropzone;
